module.exports = __webpack_public_path__ + "img/1_020.5ed2234e.jpg";